import axios from "axios";
import { safeGet } from "@/lib/storage";

// Team Work API origin. Netlify can override this at build time, but the
// production Render service remains the safe fallback so public listing
// routes never call /api on the static Netlify host by mistake.
export const BACKEND_URL = (
  process.env.REACT_APP_BACKEND_URL || "https://teamworkcom.onrender.com"
).replace(/\/$/, "");
export const API_BASE = `${BACKEND_URL}/api`;

export function resolveMediaUrl(value) {
  const raw = typeof value === "string" ? value : value?.url;
  if (!raw) return "";
  if (/^https?:\/\//i.test(raw)) return raw;
  if (raw.startsWith("/api/")) return `${BACKEND_URL}${raw}`;
  return `${API_BASE}/${raw.replace(/^\/+/, "")}`;
}

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  timeout: 45000,
});

// Attach bearer tokens when storage is available. Some browsers/PWA privacy
// modes can deny storage access; that must never crash the whole application.
api.interceptors.request.use((config) => {
  const browserStorage = typeof window !== "undefined" ? window.localStorage : null;
  const token = safeGet(browserStorage, "tw_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const customerToken = safeGet(browserStorage, "tw_customer_token");
  if (customerToken) config.headers["X-Customer-Authorization"] = `Bearer ${customerToken}`;
  return config;
});

export default api;

export function formatApiError(detail) {
  if (detail == null) return "Une erreur est survenue.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
